import { gql } from '@apollo/client';

export const MARK_CONVERSATION_AS_COMPLETED = gql`
  mutation markConversationAsCompleted($conversationId: ID!) {
    markConversationAsCompleted(conversationId: $conversationId) {
      id
      title
      isCompleted
    }
  }
`;

export const START_CONVERSATION = gql`
  mutation startConversation($type: ConversationType!) {
    startConversation(type: $type) {
      id
      title
      updatedAt
      isCompleted
      lastMessage {
        id
        content
        sender
        type
        createdAt
        status
        toolCalls {
          id
          state
          approvalId
        }
      }
    }
  }
`;
